// render.js
let canvasRender = pc.Application.getApplication();

canvasRender.autoRender = false;

window.requestAnimationFrame(renderLoop);

let secondsPassed = 0;
let oldTimeStamp = 0;
let fps;
let totalSeconds = 0;

function renderLoop(timeStamp){
    secondsPassed = (timeStamp - oldTimeStamp) / 1000;
    oldTimeStamp = timeStamp;
    totalSeconds = totalSeconds + secondsPassed;

    if(totalSeconds > 1/120){
        canvasRender.render();
        totalSeconds = 0;
        window.requestAnimationFrame(renderLoop);
        return;
    }else {
        window.requestAnimationFrame(renderLoop);
        return;
    }
    
}

